export default {
    namespaced: true,

    state: {
        account: {},
    },

    mutations: {
        setAccount(state, data) {
            state.account = data;
        },

        reset(state) {
            state.account = {};
        },
    },
};
